import axios from 'axios';
import jwt_decode from 'jwt-decode';
import authHeader from './auth-header';
import { cookieNameGenerator } from "../helpers/helpers";

const API_URL = process.env.REACT_APP_API;
const appName = process.env.REACT_APP_NAME;
const publicKey = process.env.REACT_APP_PUBLIC_KEY;
const LOGIN_PAGE = process.env.REACT_APP_LOGIN_PAGE || '/login';

const login = async (username, password) => {
	return axios
		.post(`${API_URL}auth/signin`, { username, password }, { headers: await authHeader() })
		.then(async (response) => {
			return response;
		});
};

const generateToken = async () => {
	const payload = {
		'x-public-key': publicKey,
		'x-app-name': appName,
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
	};
	return axios
		.post(
			`${API_URL}auth/app-token`,
			{},
			{
				headers: payload,
			},
		)
		.then(async (response) => {
			if (response.data.appToken) {
				localStorage.setItem('appToken', JSON.stringify(response.data));
			}

			return response;
		});
};
const logout = (removeCookie) => {
	removeCookie(cookieNameGenerator('ssocookies'));
	removeCookie(cookieNameGenerator('ssoaccount'));
	removeCookie(cookieNameGenerator('ssophonenumber'));
	localStorage.clear();
	window.location.href = LOGIN_PAGE;
	// eslint-disable-next-line no-useless-return
	return;
};

const loginPhone = async (payload) => {
	return axios
		.post(`${API_URL}auth/phone`, payload, { headers: await authHeader() })
		.then(async (response) => {
			return response;
		});
};

/**
 * appToken masih layak dipakai? Hanya token yang belum kedaluwarsa yang boleh
 * bertahan melewati pembersihan sesi.
 */
const appTokenMasihBerlaku = () => {
	try {
		const simpanan = JSON.parse(localStorage.getItem('appToken'));
		const { exp } = jwt_decode(simpanan.appToken);
		return typeof exp === 'number' && exp * 1000 > Date.now();
	} catch (e) {
		// Kosong, rusak, atau bukan JWT: tidak layak dipertahankan.
		return false;
	}
};

/**
 * Buang sesi pengguna dari localStorage, TAPI pertahankan `appToken` yang masih
 * berlaku.
 *
 * Dulu ini `localStorage.clear()`, yang ikut membuang `appToken`. Padahal
 * appToken bukan milik sesi pengguna -- ia identitas APLIKASI, dipakai sebelum
 * siapa pun login. Tanpa dia, mount `App.js` menjalankan `generateToken()` yang
 * diakhiri `window.location.reload()`, berbarengan dengan alur SSO/OIDC yang
 * mungkin sedang mengalihkan halaman -- pola lingkaran yang terukur di
 * fe-ebudgeting dan fe-work-order (Okt 2026).
 *
 * Menghapus per-kunci, bukan `clear()` lalu memasang ulang: kalau proses
 * terputus di tengah, appToken tidak pernah sempat hilang. `sessionStorage`
 * (tempat penanda `oidc_gagal`) memang tidak pernah disentuh di sini.
 * `logout()` (jalur non-SSO) tetap membuang SEMUANYA seperti dulu.
 */
const goONELNKHomapage = () => {
	const dipertahankan = appTokenMasihBerlaku() ? ['appToken'] : [];
	Object.keys(localStorage)
		.filter((kunci) => !dipertahankan.includes(kunci))
		.forEach((kunci) => localStorage.removeItem(kunci));
};

const register = async (username, email, password) => {
	return axios.post(
		`${API_URL}auth/signup`,
		{
			username,
			email,
			password,
		},
		{ headers: await authHeader() },
	);
};

const getMenu = async (role) => {
	return axios
		.get(`${API_URL}authorization/${role}`, { headers: await authHeader() })
		.then((response) => {
			localStorage.setItem('menu', JSON.stringify(response.data));
			return response.data;
		});
};

const getMenuByUsername = async (role) => {
	return axios
		.get(`${API_URL}authorization/role-by-username/`, {
			headers: await authHeader(),
			params: role,
		})
		.then((response) => {
			localStorage.setItem('menu', JSON.stringify(response.data));
			return response.data;
		});
};
const loginSSO = async (payload) => {
	return axios
		.post(`${API_URL}auth/signin-sso`, payload, { headers: await authHeader() })
		.then(async (response) => {
			return response;
		});
};

export default {
	login,
	logout,
	register,
	getMenu,
	generateToken,
	getMenuByUsername,
	loginSSO,
	goONELNKHomapage,
	loginPhone,
};
